import { PublicClientApplication } from "@azure/msal-browser";

export const getRedirectUri = () => {
  if (process.env.REACT_APP_REDIRECT_URI) {
    return process.env.REACT_APP_REDIRECT_URI;
  }
  const origin =
    typeof window !== "undefined" && window.location ? window.location.origin : "";
  if (!origin || origin === "http://localhost" || origin === "null") {
    return "http://localhost:3000";
  }
  return origin;
};

const msalConfig = {
  auth: {
    clientId: "c6544785-93b5-413c-aea5-57093a724d32",
    authority:
      "https://login.microsoftonline.com/c0807f6d-1970-4774-af4b-ccd5740e312b",
    redirectUri: getRedirectUri(),
  },
  cache: {
    cacheLocation: "localStorage",
    storeAuthStateInCookie: false,
  },
};

export const loginRequest = {
  scopes: [
    "api://c6544785-93b5-413c-aea5-57093a724d32/access_as_user",
  ],

};

export const msalInstance = new PublicClientApplication(msalConfig);